import { Component, Input } from '@angular/core';
import { FieldConfig } from '../dynamic-form/dynamic-form-config.interface';
import { FormGroup } from '@angular/forms';
import { SelectService } from './select.service';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
})
export class SelectComponent {

  @Input() field: FieldConfig;
  @Input() group: FormGroup;

  valueSelected: any;

  constructor(private selectService: SelectService) {}

  click(name: any, value: any, optName: any): void {
    if (this.valueSelected !== value) {
      this.valueSelected = value;
      this.selectService.onSelectionChange({ name, value, optName });
    } else {
    }
  }
}
